import { UpdatableObjectFilterType } from "./helpers";
import { UpdatableObject } from "./types";

// ------------------------------------
// Constants
// ------------------------------------
export const UPDATABLE_OBJECTS_GET_REQUEST = "UPDATABLE_OBJECTS_GET_REQUEST";
export const UPDATABLE_OBJECTS_GET_REQUEST_SUCCESS = "UPDATABLE_OBJECTS_GET_REQUEST_SUCCESS";
export const UPDATABLE_OBJECTS_GET_REQUEST_FAILURE = "UPDATABLE_OBJECTS_GET_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request(filterType: UpdatableObjectFilterType = "splitTunneling") {
  return {
    type: UPDATABLE_OBJECTS_GET_REQUEST,
    filterType,
  };
}

export function requestSuccess(res: UpdatableObject[], filterType: UpdatableObjectFilterType) {
  return {
    type: UPDATABLE_OBJECTS_GET_REQUEST_SUCCESS,
    data: res,
    filterType,
  };
}

export function requestFailure(error: any, filterType: UpdatableObjectFilterType) {
  return {
    type: UPDATABLE_OBJECTS_GET_REQUEST_FAILURE,
    error,
    filterType,
  };
}
